import ReactNative from '../base_components';
import React from 'react';

import CoinPrice from '../coin_price';

import { Prize } from '../../data/prizes';

const { StyleSheet, View, Image, Text, TouchableHighlight } = ReactNative;

const styles = StyleSheet.create({
  prizeButton: {
    width: '10em',
    height: '16em',
    flexDirection: 'row',
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
  },
  highlight: {
    flex: 1,
    alignSelf: 'stretch',
    borderRadius: '0.3em',
    backgroundColor: 'rgba(0,0,0,0.2)',

    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    width: '8em',
    height: '8em',
    borderRadius: '0.2em',
  },
  textWrapper: {
    marginLeft: '1em',
    marginRight: '1em',
    height: '6em',
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    color: 'white',
    fontSize: '1em',
    textAlign: 'center',
  },
});

type Props = {
  style: any;
  prize: Prize;
  onPress: (Prize) => null;
};

export default class PrizeButton extends React.PureComponent<Props> {
  _onPress = () => {
    this.props.onPress(this.props.prize);
  };
  render() {
    const { style, prize } = this.props;
    const { display_name, image_url, coin_price } = prize;

    return (
      <View style={[styles.prizeButton, style]}>
        <TouchableHighlight
          style={styles.highlight}
          underlayColor='rgba(255,255,255,0.2)'
          onPress={this._onPress}
        >
          <Image style={styles.icon} source={image_url} />
          <View style={styles.textWrapper}>
            <Text style={styles.text}>{display_name}</Text>
          </View>
          <CoinPrice price={coin_price} />
        </TouchableHighlight>
      </View>
    );
  }
}
